<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="ded"><b><i>Dedication</i></b></p>
<p class="ded1"><i>If nothing else pause and consider the unnecessary death of Second Lieutenant D.A. Addams-Williams, 4th South Wales Borderers, aged 19, leading his troops into battle at Chocolate Hill (Yilchin Burnu) 11 August 1915</i>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?c041e184